module.exports = "/* Styles inherited from parent */"